const RemoveTagHtml = (text) => {
    return text?.replace(/<[^>]*>?/gm, '');
};
export default RemoveTagHtml;